import { SubmitHandler } from 'react-hook-form';
import { useNavigate, useParams } from "react-router";
import useMenu from '../../hooks/Menu/useMenu'
import useCreateMenuItem from '../../hooks/MenuItem/useCreateMenuItem'
import MenuItemForm from "./MenuItemForm"
import Spinner from "../../components/ui/spinner";
import { useToast } from "../../context/ToastContext";

import type { 
  MenuItemVariables,
 } from "../../types/menuItemTypes";
 
const MenuItemNew = () => {
  const navigate = useNavigate();
  const { id: menuId } = useParams();
  const toast = useToast();
  const { menu, loading } = useMenu(menuId, {
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });
  const { createMenuItem } = useCreateMenuItem({
    onCompleted: (menuItemCreated) => {
      if (menuItemCreated?.menuId) {
        navigate(`/menus/${menuItemCreated.menuId}/menu_items`)
        toast.success(`Menu item created successfully`);
      };
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });

  if (loading || !menu) return <Spinner />;

  const onSubmit: SubmitHandler<MenuItemVariables> = async formValues => {
    await createMenuItem({
      sugarFree: formValues.sugarFree,
      glutenFree: formValues.glutenFree,
      cornFree: formValues.cornFree,
      dairyFree: formValues.dairyFree,
      eggsFree: formValues.eggsFree,
      fishFree: formValues.fishFree,
      legumesFree: formValues.legumesFree,
      peanutFree: formValues.peanutFree,
      seedsFree: formValues.seedsFree,
      shellfishFree: formValues.shellfishFree,
      treeNutsFree: formValues.treeNutsFree,
      vegan: formValues.vegan,
      chili: formValues.chili,
      hot: formValues.hot,
      amount: formValues.amount,
      unit: formValues.unit,
      mass: formValues.mass,
      amountInBase: formValues.amountInBase,
      price: formValues.price,
      proteins: formValues.proteins,
      fats: formValues.fats,
      carbohydrates: formValues.carbohydrates,
      calories: formValues.calories,
      image: formValues.image instanceof FileList ? formValues.image[0] : formValues.image,
      menuId: menuId,
      menuItemLangs: formValues.menuItemLangs,
      menuSectionIds: formValues.menuSectionIds
    });
  }

  return <MenuItemForm onSubmit={onSubmit} menu={menu} />
}

export default MenuItemNew;
